/** Chip semáforo do Fator de Ajuste (FA). */
import { faCor } from "../../utils/faCor";

interface Props {
  fa: number;
}

export function FaBadge({ fa }: Props) {
  const cor = faCor(fa);
  const bg =
    cor === "green"
      ? "bg-indra-positivo/15 text-indra-positivo"
      : cor === "yellow"
        ? "bg-yellow-500/15 text-yellow-400"
        : "bg-indra-negativo/15 text-indra-negativo";
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded font-mono text-xs tabular-nums ${bg}`}
    >
      {fa.toLocaleString("pt-BR", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
    </span>
  );
}
